import React from 'react';
import { Link } from 'react-router-dom';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';
import Panel from '../components/layout/Panel';
import SEO, { ROBOTS_NOINDEX } from '../components/SEO';
import { SITE, TOOLS_ROUTE } from '../content/tools';

/**
 * The catch-all route. Any URL that is not one of the declared routes would
 * otherwise render an empty <main>, so the user sees the navbar and footer
 * around nothing and assumes the page is broken rather than wrong.
 *
 * It also carries noindex robots metadata (see the matching static 404.html
 * built by src/prerender/buildHtml.js) so a crawler following a bad link never
 * sees a thin-content 200.
 */
const NotFound: React.FC = () => (
  <>
    <SEO
      title={`Page not found - ${SITE.name}`}
      description="That page does not exist. Browse the developer tools or return to the homepage."
      robots={ROBOTS_NOINDEX}
    />
    <PageShell>
      <PageHeader
        icon={faTriangleExclamation}
        title="Page not found"
        subtitle="We could not find anything at that address."
      />
      <Panel title="Where to go from here">
        <p>
          That page does not exist. The address may be misspelled, or it may point at a
          page that has since moved.
        </p>
        <p className="mb-0">
          <Link to="/">Go to the homepage</Link>
          <span aria-hidden="true"> &middot; </span>
          <Link to={TOOLS_ROUTE.path}>Browse all tools</Link>
        </p>
      </Panel>
    </PageShell>
  </>
);

export default NotFound;
